export default () => {
    const Btn = document.querySelector('.mobile.nav');
    const Panels = document.querySelectorAll('.panel_nav');
    const CloseBtns = document.querySelectorAll('.close_btn');

    Btn.addEventListener('click', () => {
        [...Panels].forEach(panel => {
            panel.className = `${panel.className} open`;
        });
    });
    [...CloseBtns].forEach(btn => {
        btn.addEventListener('click', () => {
            [...Panels].forEach(panel => {
                panel.className = panel.className.replace(/\sopen/g, '');
            });
        });
    });
    
};